import { FormControl } from '@angular/forms';

export enum OrderFormKeys {
	EMAIL = 'email',
	PHONE = 'phone',
	AGB = 'agb',
}
export type OrderForm = {
	[OrderFormKeys.EMAIL]: string;
	[OrderFormKeys.PHONE]: any;
	[OrderFormKeys.AGB]: boolean;
};

export type ControlsOf<T> = {
	[K in keyof T]: FormControl<T[K] | null>;
};
